import Header from "./header1";
import Footer from "./footer";
import { RWebShare } from "react-web-share";
import ManageAccount from "../Employee/manageAccount";
import { useNavigate, useParams } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  requestEmpLogin,
  requestFormField,
  requestEmployeeAddCompany,
  requestEmployeeAllCompany,
  requestEmployeeCompany,
  requestEmployeeDeleteCompany,
  requestEmployeeEditCompany,
} from "../Redux/actions";
import Swal from "sweetalert2";
import WOW from "wowjs";
import Breadcrumbs from "../Section/breadcrumbsSection";

function Company(props) {

  const [pagination, setpagination] = useState({});
  const navigate = useNavigate();
  const [change, setchange] = useState(false)
  const [pages, setpages] = useState([]);
  const [page_size, setpage_size] = useState(0);
  const [error, seterror] = useState("");
  const [errorIndustryId, seterrorIndustryId] = useState("");
  const [id, setid] = useState(0);
  const [company, setcompany] = useState([]);
  const [adddata, setadddata] = useState({
    name: "",
    description: "",
    gst_no: "",
    industry_id: "",
  });
  const [editdata, seteditdata] = useState({
    name: "",
    description: "",
    gst_no: "",
    industry_id: "",
  });
  const params = useParams();
  const [addmodal, setaddModal] = useState(false);
  const [editmodal, seteditModal] = useState(false);
  const [emp, setEmp] = useState({});
  const [industries, setIndustry] = useState([]);

  function validateadd() {
    let formIsValid = false;
    if (!adddata["name"]) {
      formIsValid = false;
      seterror("*Enter company name.");
    } else if (typeof adddata["name"] !== "undefined") {
        formIsValid = true;
        seterror("");
    }
    return formIsValid;
  }

  function industryadd() {
    let formIsValid = false;
    if (!adddata["industry_id"]) {
      formIsValid = false;
      seterrorIndustryId("*Select Industry.");
    } else {
      formIsValid = true;
      seterrorIndustryId("");
    }
    return formIsValid;
  }

  function validateAddForm() {
    console.log('in validate add fom');
    let validate = validateadd(); let industry = industryadd();
    let valid = validate && industry;
    return valid;
  }
  function validateedit() {
    let formIsValid = false;
    if (!editdata["name"]) {
      formIsValid = false;
      seterror("*Enter company name.");
    } else if (typeof editdata["name"] !== "undefined") {      
        formIsValid = true;
        seterror("");
    }
    return formIsValid;
  }

  function industryedit() {
    let formIsValid = false;
    if (!editdata["industry_id"]) {
      formIsValid = false;
      seterrorIndustryId("*Select Industry.");
    } else {
      formIsValid = true;
      seterrorIndustryId("");
    }
    return formIsValid;
  }

  function validateEditForm() {
    let validate = validateedit(); let industry = industryedit();
    let valid = validate && industry;
    return valid;
  }
  function onchangeadddata(e) {
    setadddata((adddata) => ({
      ...adddata,
      [e.target.name]: e.target.value,
    }));
  }
  function onchangeeditdata(e) {
    seteditdata((editdata) => ({
      ...editdata,
      [e.target.name]: e.target.value,
    }));
  }

  const addtoggle = () => setaddModal(!addmodal);
  const saveaddtoggle = (e) => {
    e.preventDefault();
    
    if (validateAddForm()) {
      props.requestEmployeeAddCompany({
        data: {
          user_id: emp.id,
          name: adddata.name,
          description: adddata.description,
          gst_no: adddata.gst_no,
          industry_id: adddata.industry_id,
        },
      });
      setadddata({
        name: "",
        description: "",
        gst_no: "",
      });
      addtoggle();
    }
  };

  useEffect(() => {
    let empLoginData = props.employee.empLoginData;
    if (empLoginData !== undefined) {
      if (empLoginData?.data?.status == "success") {
        setEmp(empLoginData.data.data);
        props.requestFormField({
          token: empLoginData.data.data.token,
        });
      } else {
        localStorage.setItem("link", "/company");
        navigate("/emplogin");
      }
    } else {
      localStorage.setItem("link", "/company");
      navigate("/emplogin");
    }
  }, [props.employee.empLoginData]);

  useEffect(() => {
    let addCompanyData = props.data.addCompanyData;
    if (addCompanyData !== undefined) {
      if (addCompanyData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Company added successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.addCompanyData = undefined;
  }, [props.data.addCompanyData]);

  useEffect(() => {
    let formfieldData = props.employee.formfieldData;
    if (formfieldData !== undefined) {
      if (formfieldData?.data?.status == "success") {
        setIndustry(formfieldData.data.data.industries);
      }
    }
  }, [props.employee.formfieldData]);

  const edittoggle = (id) => {
    if (editmodal === true) {
      seteditModal(!editmodal);
    } else {
      seteditModal(!editmodal);
      setid(id);
      seteditdata({
        name: "",
        description: "",
        gst_no: ""
      });
      props.requestEmployeeCompany({
        id: id,
      });
    }
  };

  useEffect(() => {
    let company = props.data.companyData;
    if (company !== undefined) {
      if (company.data) {
        seteditdata(company.data.data.Company[0]);
      }
    }
  }, [props.data.companyData]);

  const saveedittoggle = (e) => {
    e.preventDefault();
    if (validateEditForm()) {
      props.requestEmployeeEditCompany({
        id: id,
        data: {
          name: editdata.name,
          description: editdata.description,
          gst_no: editdata.gst_no,
          industry_id: editdata.industry_id,
        },
      });
      seteditdata({
        name: "",
        description: "",
        gst_no: "",
      });
      setid(0);
      edittoggle();
    }
  };

  useEffect(() => {
    let editCompanyData = props.data.editCompanyData;
    if (editCompanyData !== undefined) {
      if (editCompanyData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Company updated successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.editCompanyData = undefined;
  }, [props.data.editCompanyData]);

  useEffect(() => {
    console.log(props.employee);
    props.requestEmployeeAllCompany({
      page: params.page,
      page_size: params.page_size,
    });
    setpage_size(params.page_size);
  }, [params.page, params.page_size, change]);

  function onChangePageSize(e) {
    setpage_size(e.target.value);
    if (e.target.value > 0) {
      navigate(`/job/company/1/${e.target.value}`);
    }
  }

  useEffect(() => {
    new WOW.WOW().init();
    localStorage.removeItem("link");
  }, []);

  useEffect(() => {
    console.log('company data');
    console.log(props.data);
    let allCompanyData = props.data.allCompanyData;
    if (allCompanyData !== undefined) {
      if (allCompanyData.data) {
        setcompany(allCompanyData.data.data);
        setpagination(allCompanyData.data.meta);
        if (allCompanyData.data.meta.last_page < 5) {
          let array = [];
          Array.from(Array(allCompanyData.data.meta.last_page), (e, i) => {
            array.push(i + 1);
          });
          setpages(array);
        } else {
          let array = [];
          if (allCompanyData.data.meta.current_page <= 3) {
            array.push(1, 2, 3, 4, 5);
            setpages(array);
          } else if (
            allCompanyData.data.meta.last_page -
            allCompanyData.data.meta.current_page <=
            2
          ) {
            array.push(
              allCompanyData.data.meta.last_page - 4,
              allCompanyData.data.meta.last_page - 3,
              allCompanyData.data.meta.last_page - 2,
              allCompanyData.data.meta.last_page - 1,
              allCompanyData.data.meta.last_page
            );
            setpages(array);
          } else {
            array.push(
              Number(allCompanyData.data.meta.current_page) - 2,
              Number(allCompanyData.data.meta.current_page) - 1,
              allCompanyData.data.meta.current_page,
              Number(allCompanyData.data.meta.current_page) + 1,
              Number(allCompanyData.data.meta.current_page) + 2
            );
            setpages(array);
          }
        }
      }
    }
  }, [props.data.allCompanyData]);
  const CustomUI = ({ onSubmit, onCancel }) => (
    <div
      className="custom-ui"
      style={{
        backgroundColor: "white",
        width: "350px",
        padding: "25px",
        border: "1px solid black",
        margin: "auto",
      }}
    >
      <h3>Are you sure?</h3>
      <p>
        Do you really want to delete this records? This process cannot be
        undone.
      </p>
      <div>
        <button
          onClick={onSubmit}
          style={{ border: "0px", backgroundColor: "green", color: "white", padding: "2px 10px" }}
        >
          Yes
        </button>
        <button
          onClick={onCancel}
          style={{
            border: "0px",
            backgroundColor: "red",
            color: "white",
            marginLeft: "10px",
            padding: "2px 10px"
          }}
        >
          No
        </button>
      </div>
    </div>
  );
  function deletedata(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        props.requestEmployeeDeleteCompany({
          id: id,
        });
      }
    })
  }

  useEffect(() => {
    let deleteCompanyData = props.data.deleteCompanyData;
    if (deleteCompanyData !== undefined) {
      if (deleteCompanyData.data) {
        Swal.fire({
          title: 'Good job!',
          text: 'Company deleted successfully..',
          icon: 'success'
        });
        setchange(!change)
      }
    }
    props.data.deleteCompanyData = undefined;
  }, [props.data.deleteCompanyData]);

  function printPage() {
    var printContents =
      "<br/><center><h3>Companies</h3></center>" +
      document.getElementById("printme").innerHTML;
    var originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  }

  return (
    <>
      <div class="container-scroller">
        <Header name="Companys" />
        <div class="container-fluid page-body-wrapper">
          <ManageAccount name="company" />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-sm-12">
                  <div class="home-tab">
                    <div class="row flex-grow">
                      <div class="col-12 grid-margin stretch-card">
                        <div class="card card-rounded">
                          <div class="card-body">
                            <div class="d-sm-flex justify-content-between align-items-start">
                              <div class="btn-wrapper">
                                <RWebShare
                                  data={{
                                    text: "Job Portal",
                                    url: `http://localhost:3000/employee/company/${params.page}/${params.page_size}`,
                                    title: "Job Portal",
                                  }}
                                >
                                  <p class="btn btn-otline-dark align-items-center">
                                    <i class="icon-share"></i> Share
                                  </p>
                                </RWebShare>
                                <button
                                  onClick={printPage}
                                  class="btn btn-otline-dark"
                                >
                                  <i class="icon-printer"></i> Print
                                </button>
                              </div>
                              <div>
                                <button
                                  class="btn btn-primary btn-md text-white mb-0 me-0"
                                  type="button"
                                  onClick={addtoggle}
                                >
                                  Add new company
                                </button>
                                <Modal isOpen={addmodal} toggle={addtoggle}>
                                  <ModalHeader toggle={addtoggle}>
                                    Add Company
                                  </ModalHeader>
                                  <ModalBody>
                                    <form class="forms-sample">
                                      <div class="form-group">
                                        <label>Name</label>
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="Name"
                                          name="name"
                                          value={adddata.name}
                                          onBlur={validateadd}
                                          onChange={onchangeadddata}
                                        />
                                        {error && <p>{error}</p>}
                                        <label>Description*</label>
                                        <div class="col-lg-12">
                                                <textarea
                                                class="form-control"
                                                rows="5"
                                                name="description"
                                                // value={data.description}
                                                onChange={onchangeadddata}
                                                placeholder=""
                                                ></textarea>
                                        </div>
                                        <label>
                                          <br />
                                          Industry
                                        </label>
                                        <select
                                          class="form-select"
                                          name="industry_id"
                                          // value={data.functional_area}
                                          onBlur={industryadd}
                                          onChange={onchangeadddata}
                                        >
                                          <option value="0">Select Industry</option>
                                          {industries.map((option) => (
                                            <option value={option.id}>{option.name}</option>
                                          ))}
                                        </select>
                                        {errorIndustryId && <p>{errorIndustryId}</p>}
                                        <label>
                                          <br />
                                          GST No.
                                        </label>
                                        <input
                                          type="text"
                                          name="gst_no"
                                          class="form-control"
                                          placeholder="GST No."
                                          value={adddata.gst_no}
                                          onChange={onchangeadddata}
                                        />
                                      </div>
                                      <button
                                        type="submit"
                                        class="btn btn-primary me-2"
                                        onClick={saveaddtoggle}
                                      >
                                        Submit
                                      </button>
                                      <button
                                        class="btn btn-light"
                                        onClick={addtoggle}
                                      >
                                        Cancel
                                      </button>
                                    </form>
                                  </ModalBody>
                                </Modal>
                              </div>
                            </div>
                            <br />
                            <div class="table-responsive  mt-1" id="printme">
                              <table class="table select-table">
                                <thead>
                                  <tr>
                                    <th>Company</th>
                                    <th>Industry</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {company}
                                  {company.map((item, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div class="d-flex ">
                                            <div>
                                              <h6>{item.name}</h6>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <p>{item.industry_id}</p>
                                        </td>
                                        <td>
                                          <p>{item.created_at.substring(0, 10)}</p>
                                        </td>
                                        <td>
                                          <p>{item.updated_at.substring(0, 10)}</p>
                                        </td>
                                        <td>
                                          <button
                                            class="badge badge-opacity-success"
                                            style={{
                                              border: "0px",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {
                                              edittoggle(item.id);
                                            }}
                                          >
                                            <i class="fa fa-pencil-square-o"></i>
                                          </button>
                                          {editmodal === true && (
                                            <Modal
                                              isOpen={editmodal}
                                              toggle={edittoggle}
                                            >
                                              <ModalHeader toggle={edittoggle}>
                                                Edit Company
                                              </ModalHeader>
                                              <ModalBody>
                                                <form class="forms-sample">
                                                  <div class="form-group">
                                                    <label>Name</label>
                                                    <input
                                                      type="text"
                                                      class="form-control"
                                                      placeholder="Name"
                                                      name="name"
                                                      value={editdata.name}
                                                      onBlur={validateedit}
                                                      onChange={
                                                        onchangeeditdata
                                                      }
                                                    />
                                                    {error && <p>{error}</p>}
                                                    <label>
                                                      <br />
                                                      Description
                                                    </label>
                                                    <textarea
                                                        class="form-control"
                                                        rows="5"
                                                        name="description"
                                                        value={editdata.description}
                                                        onChange={onchangeeditdata}
                                                        placeholder="">
                                                    </textarea>
                                                    <label>
                                                      <br />
                                                      Industry
                                                    </label>
                                                    <select
                                                      class="form-select"
                                                      name="industry_id"
                                                      value={editdata.industry_id}
                                                      onBlur={industryedit}
                                                      onChange={onchangeeditdata}
                                                    >
                                                      <option value="0">Select Industry</option>
                                                      {industries.map((option) => (
                                                        <option value={option.id}>{option.name}</option>
                                                      ))}
                                                    </select>
                                                    {errorIndustryId && <p>{errorIndustryId}</p>}
                                                    <label>
                                                      <br />
                                                      GST No
                                                    </label>
                                                    <input
                                                      type="text"
                                                      name="gst_no"
                                                      class="form-control"
                                                      placeholder="GST No."
                                                      value={editdata.gst_no}
                                                      onChange={onchangeadddata}
                                                    />
                                                  </div>

                                                  <button
                                                    type="submit"
                                                    class="btn btn-primary me-2"
                                                    onClick={saveedittoggle}
                                                  >
                                                    Submit
                                                  </button>
                                                  <button
                                                    class="btn btn-light"
                                                    onClick={edittoggle}
                                                  >
                                                    Cancel
                                                  </button>
                                                </form>
                                              </ModalBody>
                                            </Modal>
                                          )}
                                          <button
                                            class="badge badge-opacity-danger"
                                            style={{
                                              border: "0px",
                                              background: "#fea8a9",
                                              marginLeft: "5px",
                                            }}
                                            onClick={() => {
                                              deletedata(item.id);
                                            }}
                                          >
                                            <i class="fa fa-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            <div class="row">
                              <div class="col-10">
                                <div class="pagination center">
                                  <ul class="pagination-list">
                                    {pagination.current_page !== 1 && (
                                      <li>
                                        <a
                                          href={`/job/company/${params.page - 1
                                            }/${params.page_size}`}
                                        >
                                          <i class="fa fa-long-arrow-left"></i>
                                        </a>
                                      </li>
                                    )}
                                    {pages.map((i) => {
                                      return pagination.current_page === i ? (
                                        <li class="active">
                                          <a
                                            href={`/job/company/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      ) : (
                                        <li>
                                          <a
                                            href={`/job/company/${i}/${params.page_size}`}
                                          >
                                            {i}
                                          </a>
                                        </li>
                                      );
                                    })}
                                    {pagination.current_page !==
                                      pagination.last_page && (
                                        <li>
                                          <a
                                            href={`/job/company/${Number(params.page) + 1
                                              }/${params.page_size}`}
                                          >
                                            <i class="fa fa-long-arrow-right"></i>
                                          </a>
                                        </li>
                                      )}
                                  </ul>
                                </div>
                              </div>
                              <div class="col-2">
                                <div class="pagination center">
                                  <form onSubmit={onChangePageSize}>
                                    <div class="form-group">
                                      <input
                                        type="number"
                                        class="form-control"
                                        placeholder={page_size}
                                        name="page_size"
                                        value={page_size}
                                        onChange={onChangePageSize}
                                        style={{ width: "100px" }}
                                      />
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return { employee: state.employee, data: state.data };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      requestEmpLogin, requestFormField,
      requestEmployeeAddCompany,
      requestEmployeeAllCompany,
      requestEmployeeCompany,
      requestEmployeeDeleteCompany,
      requestEmployeeEditCompany,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Company);